import {
    Component,
    Input,
} from '@angular/core';


@Component({
    selector: 'agpr-personalization-detail-card',
    templateUrl: './personalization-detail-card.component.html',
    styleUrls: ['./personalization-detail-card.component.scss'],
    standalone: false
})
export class PersonalizationDetailCardComponent {
    @Input() label: string;
    @Input() value: number;
    @Input() maxValue: number;
    @Input() color: string = '';
    @Input() estimate: boolean = false;
}
